(function() {
  function initSplide() {
    if (typeof Splide === 'undefined') {
      setTimeout(initSplide, 100);
      return;
    }

    if (document.getElementById('product_slider')) {
    let main = new Splide('#product_slider', {
        start: 0,
        type: 'slide',
        rewind: false,
        pagination: true,
        perPage: 1,
        snap: true,
        arrows: true,
        gap: 0,
        lazyLoad: 'nearby',
        cover: false,
        height: '850px', // Height for laptop and larger screens
        breakpoints: {

        '768': { 
            height: 'auto',
            rewind: true,
            rewindByDrag: true,
            type: 'loop',
            drag: 'free',
            height: '550px',
            flickPower: 300,
            focus: 'center',
        },
        },
    });

        main.on('moved', function() {
            let lastSlide = document.querySelector('.splide__slide:last-child');
            if (main.index === main.length - 1) {
                lastSlide.style.paddingRight = '0';
            } else {
                lastSlide.style.paddingRight = '';
            }
        });

        // Only initialize and run the thumbnail slider if there is more than one slide in the main slider
        if (document.getElementById('thumbnail-slider')) {
            let thumbnails = new Splide('#thumbnail-slider', {
                type: 'slide',
                start: 1,
                gap: 10,
                perPage: 4,
                easing: 'ease',
                pagination: false,
                cover: true,
                isNavigation: true,
                arrows: false,
                fixedWidth: 220,
                fixedHeight: 330,
                direction: 'ttb',
                height: '850px',
                wheel: true,
                wheelSleep: 500,
                speed: 1000,
                rewind: true,
                lazyLoad: 'nearby',
                breakpoints: {
                    '768': {
                        destroy: true,
                    }
                },
            });

            // Mount independently (no sync) so thumbnails can start at index 1
            main.mount();
            thumbnails.mount();

            // Manual sync: when main slider moves, update thumbnails
            main.on('moved', function(newIndex) {
                thumbnails.go(newIndex);
            });

            // Manual sync: when a thumbnail is clicked, navigate main slider
            thumbnails.on('click', function(slideComponent) {
                main.go(slideComponent.index);
            });

        } else {
            main.mount();
        }

    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSplide);
  } else {
    initSplide();
  }
})();

(function() {
  function initLightbox() {
    const gallery = document.getElementById('product_slider');
    if (gallery) {
        new SimpleLightbox('#product_slider a', {
            history: true,
            alertError: false,
            additionalHtml: false,
            loop: true,
            overlayOpacity: 1,
            doubleTapZoom: 2,
            fadeSpeed: 50,
            animationSpeed: 50,
            swipeClose: false,
            enableZoom: true
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();